import React from 'react'

export default function Cancel() {
  return <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 16.1H2V2H20V16.1ZM20 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H20C21.1 18 22 17.1 22 16V2C22 0.9 21.1 0 20 0Z" fill="#BBBBBB"/>
		<path d="M13.59 5L11 7.59L8.41 5L7 6.41L9.59 9L7 11.59L8.41 13L11 10.41L13.59 13L15 11.59L12.41 9L15 6.41L13.59 5Z" fill="#BBBBBB"/>
	</svg>
}
